import forEach from 'lodash/forEach'
import {exhaustive} from '@freckle/exhaustive'

import {
  type SyncResultT,
  type SyncResultFailureT,
  type SyncResultSuccessT
} from '@frontrow/console/src/entities/models/roster-sync'

export function partitionResults(
  results: Array<SyncResultT>
): [Array<SyncResultFailureT>, Array<SyncResultSuccessT>] {
  const failures: SyncResultFailureT[] = []
  const successes: SyncResultSuccessT[] = []
  forEach(results, result => {
    switch (result.tag) {
      case 'SyncResultSuccess':
        successes.push(result.contents)
        break
      case 'SyncResultFailure':
        failures.push(result.contents)
        break
      default:
        return exhaustive(result, 'SyncResultT')
    }
  })
  return [failures, successes]
}
